import { useEventCallback, useFluent } from '@fluentui/react-components';
import * as React from 'react';
import { EVENTS } from '../types';
const DEFAULT_STEP = 20;
const multipliers = {
  end: {
    ArrowRight: 1,
    ArrowLeft: -1
  },
  start: {
    ArrowRight: -1,
    ArrowLeft: 1
  },
  up: {
    ArrowUp: 1,
    ArrowDown: -1
  },
  down: {
    ArrowUp: -1,
    ArrowDown: 1
  }
};
function isSupportedKey(growDirection, key) {
  return Object.prototype.hasOwnProperty.call(multipliers, growDirection) && Object.prototype.hasOwnProperty.call(multipliers[growDirection], key);
}
export const useKeyboardHandler = options => {
  const {
    onValueChange,
    growDirection,
    getCurrentValue
  } = options;
  const {
    dir
  } = useFluent();
  const onKeyDown = useEventCallback(event => {
    if (!isSupportedKey(growDirection, event.key)) {
      return;
    }
    let newValue = getCurrentValue();
    var _multipliers_growDirection_event_key;
    const multiplier = (_multipliers_growDirection_event_key = multipliers[growDirection][event.key]) != null ? _multipliers_growDirection_event_key : 1;
    const directionMultiplier = dir === 'rtl' && ['start', 'end'].includes(growDirection) ? -1 : 1;
    newValue += multiplier * DEFAULT_STEP * directionMultiplier;
    onValueChange(event, {
      event,
      value: Math.round(newValue),
      type: EVENTS.keyboard
    });
  });
  const attachHandlers = React.useCallback(node => {
    node.addEventListener('keydown', onKeyDown);
  }, [onKeyDown]);
  const detachHandlers = React.useCallback(node => {
    node.removeEventListener('keydown', onKeyDown);
  }, [onKeyDown]);
  return {
    attachHandlers,
    detachHandlers
  };
};